import { V2_PATHS } from "../../universal/v2Routes";

export const DEFAULT_ACCOUNT_SETTINGS_SECTION = "account";

export const ACCOUNT_SETTINGS_SECTIONS = [
    { id: "account", label: "Account" },
    { id: "public-profile", label: "Public Profile" },
    { id: "two-factor-auth", label: "Two-Factor Auth" },
    { id: "notifications", label: "Notifications" },
    { id: "subscriptions", label: "Subscriptions" },
    { id: "referral-program", label: "Referral Program" },
    { id: "my-reports", label: "My reports" },
    { id: "support-tickets", label: "Support tickets" },
];

export const ACCOUNT_SETTINGS_SECTION_IDS = ACCOUNT_SETTINGS_SECTIONS.map(
    (section) => section.id,
);

const ACCOUNT_SETTINGS_SECTION_ALIASES = {
    "2fa": "two-factor-auth",
    "social-details": "public-profile",
};

export function resolveAccountSettingsSection(sectionParam) {
    const aliased = ACCOUNT_SETTINGS_SECTION_ALIASES[sectionParam];
    if (aliased) {
        return aliased;
    }

    if (ACCOUNT_SETTINGS_SECTION_IDS.includes(sectionParam)) {
        return sectionParam;
    }

    return DEFAULT_ACCOUNT_SETTINGS_SECTION;
}

export function toSettingsSectionPath(sectionId) {
    return `${V2_PATHS.settings}/${resolveAccountSettingsSection(sectionId)}`;
}

export function getAccountSettingsSectionFromPathname(pathname = "") {
    const normalized = pathname.replace(/\/+$/, "") || "/";
    const prefixes = [`${V2_PATHS.settings}/`, "/settings-v2/"];

    for (const prefix of prefixes) {
        if (normalized.startsWith(prefix)) {
            return resolveAccountSettingsSection(normalized.slice(prefix.length));
        }
    }

    return DEFAULT_ACCOUNT_SETTINGS_SECTION;
}

export function getAccountSettingsSectionFromLocation(location) {
    const params = new URLSearchParams(location?.search);
    const fromSearch = params.get("section");
    if (fromSearch) {
        return resolveAccountSettingsSection(fromSearch);
    }

    return getAccountSettingsSectionFromPathname(location?.pathname);
}

export function replaceSettingsSectionUrl(sectionId) {
    if (typeof window === "undefined") {
        return;
    }

    const nextPath = toSettingsSectionPath(sectionId);
    const currentPath = `${window.location.pathname}${window.location.search}`;
    if (currentPath === nextPath) {
        return;
    }

    window.history.replaceState(window.history.state, "", nextPath);
}
